import * as babylon from "@babylonjs/core";

import { BabylonTheme, Callbacks } from "../state";

export function initScene(
  engine: babylon.Engine,
  theme: BabylonTheme,
  callbacks: Callbacks,
): babylon.Scene {
  // This creates a basic Babylon Scene object (non-mesh)
  const scene = new babylon.Scene(engine);

  scene.executeWhenReady(() => {
    callbacks.onSceneLoadingChanged(false);
  });

  // Lighting setup
  scene.clearColor = theme.backgroundColor;
  scene.ambientColor = new babylon.Color3(0.8, 0.8, 0.8);
  const light = new babylon.DirectionalLight(
    "Sunlight-45-degree",
    new babylon.Vector3(1, -1, 0),
  );
  scene.addLight(light);
  scene.lightsEnabled = true;

  // fog
  // Currently the fog is only really used for the grid -- as an alternative, we could fade the grid to 0 opacity in the distance.
  // However, fog is more performant than transparent materials are.
  scene.fogMode = babylon.Scene.FOGMODE_EXP;
  scene.fogEnabled = true;
  scene.fogColor = new babylon.Color3(
    theme.backgroundColor.r,
    theme.backgroundColor.g,
    theme.backgroundColor.b,
  );
  scene.fogDensity = 0.00001;
  return scene;
}
